var map = {
	"./bell.svg": 42554,
	"./bubble-bind.svg": 30721,
	"./close-fill.svg": 96042,
	"./coin.svg": 21439,
	"./creator-idea.svg": 98283,
	"./detail.svg": 38255,
	"./dot.svg": 32874,
	"./inviter.svg": 18271,
	"./money-bag.svg": 86955,
	"./no-data.svg": 67965,
	"./persion.svg": 92975,
	"./scholar-cap.svg": 90298,
	"./star-tag.svg": 95056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;